import React from 'react';
import { compose, withHandlers, withProps } from 'recompose';
import SubPageWrapper from '../../common/SubPageWrapper';
import HeaderDropdown from './headerDropdown';

export default compose(
  withHandlers({
    getCurrentPage: props => () => {
      const { page, pages } = props;
      return (
        pages[page] ||
        pages['edit-shop'] ||
        pages['change-password']
      );
    },
  }),
  withProps(props => ({
    dropdown: <HeaderDropdown title={props.getCurrentPage().title} />,
  })),
)(SubPageWrapper);
